function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M134.6,70.5h3.4c9.4,0,16,5.6,16,15.7c0,10.9-7.4,15.7-16.1,15.7h-3.3V70.5z M120.1,114.2h20.6 c15.5,0,28.4-12.2,28.4-28c0-15.7-12.8-28-28.4-28h-20.6V114.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.1,93.3H80l6-17.8h0.1L92.1,93.3z M96,104.5l3.6,9.7h15.5l-21.1-56H78.2l-21.5,56h15.4l3.9-9.7H96z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "284.2,114.2 298.7,114.2 298.7,79.9 298.9,79.9 325.6,114.2 340.1,114.2 340.1,58.2 325.6,58.2  325.6,92.4 325.4,92.4 298.7,58.2 284.2,58.2  "
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M215.8,95.9c-2.8,3.3-7,5.4-11.6,5.4c-8.4,0-15.2-6.8-15.2-15.2S195.7,71,204.1,71c4.7,0,8.8,2.1,11.6,5.4 c1.4-4.9,3.8-9.3,7-13.1c-5.1-4.1-11.6-6.6-18.6-6.6c-16.3,0-29.5,13.2-29.5,29.5c0,16.3,13.2,29.5,29.5,29.5 c7.1,0,13.6-2.5,18.6-6.6C219.6,105.2,217.2,100.8,215.8,95.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M221.4,86.2c0-0.4,0-0.8,0-1.2H212c-0.6-3.9-3.9-6.8-7.9-6.8c-4.4,0-8,3.6-8,8s3.6,8,8,8c4,0,7.3-3,7.9-6.8h9.4 C221.4,87,221.4,86.6,221.4,86.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M249.7,57.8c-15.3,0-27.7,12.1-28.3,27.2h20.4c0.6-3.9,3.9-6.8,7.9-6.8c4.4,0,8,3.6,8,8s-3.6,8-8,8 c-4,0-7.3-3-7.9-6.8h-20.4c0.6,15.1,13.1,27.1,28.3,27.1c15.7,0,28.3-12.7,28.3-28.3S265.4,57.8,249.7,57.8z"
}));

var SvgAdconLogoWhite = function SvgAdconLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Dcon_Logo_4C",
    x: "0px",
    y: "0px",
    viewBox: "32 0 332.8 172.4",
    style: {
      fill: "#FFFFFF"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdconLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ADCON_Logo_white.c781b0f3.svg";
export { ForwardRef as ReactComponent };